<template>
  <main class="not-found">
    <p class="not-found-code">404</p>
    <h1>{{ copy.title }}</h1>
    <p class="not-found-sub">{{ copy.subtitle }}</p>
    <router-link class="not-found-link" to="/">{{ copy.backHome }}</router-link>
  </main>
  <AppFooter />
</template>

<script>
import AppFooter from "../components/AppFooter.vue";

export default {
  name: "NotFound",
  components: {
    AppFooter,
  },
  computed: {
    copy() {
      const rawLocale = this.$i18n?.locale;
      const locale =
        (typeof rawLocale === "string" ? rawLocale : rawLocale?.value) || "en";

      if (locale.startsWith("fr")) {
        return {
          title: "Page introuvable",
          subtitle: "La page que vous cherchez n'existe pas ou a été déplacée.",
          backHome: "Retour à l'accueil",
        };
      }

      return {
        title: "Page not found",
        subtitle: "The page you're looking for doesn't exist or has been moved.",
        backHome: "Back to home",
      };
    },
  },
};
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 88px 20px 48px;
  color: var(--app-text);
}

.not-found-code {
  font-size: 72px;
  font-weight: 700;
  margin: 0 0 8px;
  opacity: 0.15;
  line-height: 1;
}

h1 {
  margin: 0 0 12px;
}

.not-found-sub {
  opacity: 0.6;
  margin: 0 0 32px;
}

.not-found-link {
  color: var(--app-link);
  text-decoration: none;
  font-size: 18px;
  display: inline-block;
}

.not-found-link:hover {
  color: var(--app-link-hover);
  text-decoration: underline;
}
</style>
